export function getCsrfCode(sKey) {
  if (!sKey) {
    return '';
  }
  let hash = 5381;
  for (let i = 0, len = sKey.length; i < len; i += 1) {
    hash += (hash << 5) + sKey.charCodeAt(i);
  }
  return hash & 0x7fffffff;
}
